import React from 'react';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import MarvelLogo from 'marketing-website/components/commons/MarvelLogo';

import FooterColumn from './FooterColumn';
import FooterLink from './FooterLink';

import generalStyles from './style/general.module.css';

export default function Footer() {
  return (
    <footer className={generalStyles.footer}>
      <Spacing type="padding" size="m" sizeM="0" position="leftRight">
        <PageWrap size="l">
          <Spacing type="padding" size="l" position="topBottom">
            <Spacing type="padding" sizeM="xl" position="topBottom">
              <Grid columns={12}>
                <GridItem columnSpan={12} columnSpanM={2}>
                  <Spacing type="margin" size="m" position="topBottom">
                    <Align type="center" typeM="left">
                      <MarvelLogo size="m" color="white" />
                    </Align>
                  </Spacing>
                </GridItem>
                <FooterColumn title="Platform">
                  <FooterLink to="/why-marvel">Why Marvel</FooterLink>
                  <FooterLink to="/enterprise">Enterprise</FooterLink>
                  <FooterLink url="https://ballparkhq.com/?utm_campaign=Ballpark%20Launch%200422&utm_source=Marvel%20blog&utm_medium=footer-banner">
                    Ballpark - User research for teams
                  </FooterLink>
                  <FooterLink to="/apps">Mobile Apps</FooterLink>
                  <FooterLink to="/pricing">Pricing</FooterLink>
                  <FooterLink to="/developers/">Developer API</FooterLink>
                  <FooterLink to="/marvel-vs-invision/">
                    Marvel vs InVision
                  </FooterLink>
                  <FooterLink to="/marvel-vs-zeplin">
                    Marvel vs Zeplin
                  </FooterLink>
                  <FooterLink to="/financial-services">
                    Marvel for Finance
                  </FooterLink>
                  <FooterLink to="/consultancies">
                    Marvel for Consultancies
                  </FooterLink>
                  <FooterLink to="/prototyping-for-design-agencies">
                    Marvel for Agencies
                  </FooterLink>
                </FooterColumn>
                <FooterColumn title="Features">
                  <FooterLink to="/features/design">Design</FooterLink>
                  <FooterLink to="/features/wireframing">
                    Wireframing
                  </FooterLink>
                  <FooterLink to="/features/prototyping">
                    Prototyping
                  </FooterLink>
                  <FooterLink to="/features/handoff">Handoff</FooterLink>
                  <FooterLink to="/user-testing">User Testing</FooterLink>
                  <FooterLink to="/features/collaboration">
                    Collaboration
                  </FooterLink>
                  <FooterLink to="/features/integrations">
                    Integrations
                  </FooterLink>
                </FooterColumn>
                <FooterColumn title="Support">
                  <FooterLink url="https://help.marvelapp.com/hc/en-us?utm_source=marketingsite&utm_medium=helpbuttonfooter&utm_campaign=hcdirectlink">
                    Help Center
                  </FooterLink>
                  <FooterLink to="/terms">Terms of Service</FooterLink>
                  <FooterLink to="/privacy">Privacy</FooterLink>
                  <FooterLink url="https://status.marvelapp.com">
                    Status
                  </FooterLink>
                  <FooterLink to="/security">Security</FooterLink>
                  <FooterLink to="/resources">Resources</FooterLink>
                  <FooterLink to="/designglossary">Design Glossary</FooterLink>
                  <FooterLink className="termly-display-preferences" to="#">
                    Consent Preferences
                  </FooterLink>
                </FooterColumn>
                <FooterColumn title="Company">
                  <FooterLink url="https://blog.marvelapp.com/">
                    Blog
                  </FooterLink>
                  <FooterLink to="/about-us">About Us</FooterLink>
                  <FooterLink to="/about-us#openpositions">Jobs</FooterLink>
                  <FooterLink to="/contact-us">Contact Us</FooterLink>
                  <FooterLink to="/customer-stories">
                    Customer Stories
                  </FooterLink>
                  <FooterLink to="/labs">Labs</FooterLink>
                  <FooterLink url="https://marvel.workable.com/">
                    Careers
                  </FooterLink>
                </FooterColumn>
                <FooterColumn title="Follow">
                  <FooterLink url="https://twitter.com/marvelapp">
                    Twitter
                  </FooterLink>
                  <FooterLink url="https://dribbble.com/marvelapp">
                    Dribbble
                  </FooterLink>
                  <FooterLink url="https://www.facebook.com/marvelapp">
                    Facebook
                  </FooterLink>
                  <FooterLink url="https://github.com/marvelapp">
                    Github
                  </FooterLink>
                  <FooterLink url="https://www.linkedin.com/company/marvel-app/">
                    Linkedin
                  </FooterLink>
                </FooterColumn>
              </Grid>
            </Spacing>
          </Spacing>
        </PageWrap>
      </Spacing>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/Footer/index.js